module.exports = __webpack_public_path__ + "img/horizontal_6_3_8023.cbdaa16c.png";